module.exports = __webpack_public_path__ + "img/CCLF_infographic-17.97d0bed3.png";